import { combineReducers } from "redux";
import albums from "./albums";
import song from "./song";
import current from "./currentalbum";
import isplaying from "./isplaying";
import image_handler from "./toggleArtworkDisplay";
import repeat from "./togglerepeat";
export default combineReducers({ albums, song, current, isplaying, image_handler, repeat });
